export default "__VITE_ASSET__DRA0WFEy__"